import { Button, Flex, Text, Tooltip } from '@optiaxiom/react';
import { IconArrowRotateLeft } from '@optimizely/axiom-icons';

import HeaderWithTooltip from './HeaderWithTooltip';

type EnabledInChatHeaderProps = {
  enabledCount: number;
  onRestoreToolsClick?: () => void;
};

const EnabledInChatHeader = ({ enabledCount, onRestoreToolsClick }: EnabledInChatHeaderProps) => (
  <Flex flexDirection="row" justifyContent="space-between" alignItems="center" w="full">
    <Flex flexDirection="column" gap="2">
      <HeaderWithTooltip
        label="Enabled in Chat"
        info="Toggle to make this tool available for direct messages in Opal chat. Agents triggered from chat can use this tool regardless of this setting. A maximum of 128 tools can be enabled."
      />
      <Text fontSize="xs" color="fg.secondary">
        ({enabledCount} / max. 128)
      </Text>
    </Flex>
    <Flex>
      <Tooltip content="Restore tools for chat">
        <Button
          onClick={onRestoreToolsClick}
          disabled={!onRestoreToolsClick}
          icon={<IconArrowRotateLeft />}
        />
      </Tooltip>
    </Flex>
  </Flex>
);

export default EnabledInChatHeader;
